import React from 'react';
import { getHorarioHoje as getHorarioHojeUtil, getStatusLoja } from '../utils/horarioUtils';

function Footer({ loja, onMeusPedidosClick, onLoginClick, onCriarContaClick }) {
  const currentYear = new Date().getFullYear();
  
  const formatarEndereco = (endereco) => {
    if (!endereco) return null;
    if (typeof endereco === 'string') return endereco;
    const { logradouro, numero, bairro, cidade, uf } = endereco;
    return `${logradouro}${numero ? ', ' + numero : ''} - ${bairro}, ${cidade}/${uf}`;
  };

  const getHorarioHoje = () => {
    if (!loja?.horarios || loja.horarios.length === 0) return null;
    
    const horarioInfo = getHorarioHojeUtil(loja.horarios);
    const status = getStatusLoja(loja);
    
    if (status.status === 'FECHAMENTO_TEMPORARIO') {
      return { status: 'Temporariamente fechada', horario: null, isOpen: false };
    }
    
    return { 
      status: horarioInfo.aberto ? 'Hoje aberto' : 'Hoje fechado', 
      horario: horarioInfo.aberto ? horarioInfo.texto : null,
      isOpen: horarioInfo.aberto && status.aberta
    };
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Logo + Nome */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
          <img
            src={loja?.logo_url ? `https://grubupload.s3.amazonaws.com/${loja.logo_url}` : 'https://grubicons.s3.us-east-1.amazonaws.com/foto-padrao-grub-digital.jpg'}
            alt={loja?.nome || 'Logo'}
            style={{ width: '48px', height: '48px', borderRadius: '8px', objectFit: 'cover' }}
            onError={(e) => { e.target.src = 'https://grubicons.s3.us-east-1.amazonaws.com/foto-padrao-grub-digital.jpg'; }}
          />
          <h3 style={{ margin: 0, fontSize: '1.4rem', fontWeight: 600, color: '#333' }}>{loja?.nome || 'GRUB DIGITAL'}</h3>
        </div>

        {/* Descrição */}
        {loja?.descricao && (
          <p style={{ color: '#666', fontSize: '0.88rem', margin: '0 0 20px', lineHeight: '1.5', textAlign: 'left' }}>{loja.descricao}</p>
        )}

        {/* Informações de contato */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '20px' }}>
          {loja?.endereco && (
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', color: '#555', fontSize: '0.88rem' }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginTop: '2px', flexShrink: 0 }}>
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
              <span>{formatarEndereco(loja.endereco)}</span>
            </div>
          )}

          {loja?.telefone && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#555', fontSize: '0.88rem' }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
              </svg>
              <span>{loja.telefone}</span>
            </div>
          )}

          {loja?.horarios && loja.horarios.length > 0 && (() => {
            const info = getHorarioHoje();
            return info && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#555', fontSize: '0.88rem' }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12 6 12 12 16 14"></polyline>
                </svg>
                <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <span style={{
                    width: '7px', height: '7px', borderRadius: '50%',
                    backgroundColor: info.isOpen ? '#10b981' : '#ef4444',
                    animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                  }} />
                  {info.status}{info.horario && ` · ${info.horario}`}
                </span>
              </div>
            );
          })()}
        </div>

        {/* Links de navegação removidos */}
      </div>

      <div className="footer-bottom" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
        <p style={{ margin: 0 }}>
          © {currentYear} {loja?.nome || 'Grub Digital'}.{' '}
          <a href="https://grub.digital/politica-de-privacidade.html" target="_blank" rel="noopener noreferrer" style={{ color: '#999', textDecoration: 'none' }}>
            Política de Privacidade
          </a>
        </p>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <p style={{ margin: 0 }}>
            Powered by{' '}
            <a href="https://grub.digital/" target="_blank" rel="noopener noreferrer">
              <img 
                src="https://grubicons.s3.amazonaws.com/logo.svg" 
                alt="Grub Digital" 
                style={{ height: '21px', verticalAlign: 'middle', marginLeft: '4px' }}
              />
            </a>
          </p>
          <span style={{ width: '1px', height: '20px', backgroundColor: '#ddd' }}></span>
          <a href="https://www.asaas.com/" target="_blank" rel="noopener noreferrer">
            <img 
              src="https://baas.asaas.com/selos/Servicos_financeiros_Asaas-Reduzida-Positivo.svg?id=cfdd4cce-dfc2-4709-9917-381cbcff8bd0" 
              alt="Asaas - Serviços Financeiros" 
              style={{ height: '28px', verticalAlign: 'middle' }}
            />
          </a>
        </div>
      </div>

      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
      `}</style>
    </footer>
  );
}

export default Footer;
